import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Typography } from '@material-ui/core';
import NumberRule from './NumberRule';
import SelectTextField from '../../../../../../Common/UI/SelectTextField';

class AreaRule extends React.Component {
    static propTypes = {
        tree: PropTypes.object.isRequired,
        field: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange (event) {
        const { tree, onChange } = this.props;
        const newTree = { ...tree };
        newTree.properties = {
            ...newTree.properties,
            [event.target.name]: event.target.value
        };

        const unit = newTree.properties?.unit;
        const field = newTree?.field;
        if(field === "area" && (unit !== undefined)) newTree['isValid'] =  true;
        if(field === "area" && (unit === undefined)) newTree['isValid'] = false;
        onChange(newTree);
    }



    render () {
        const { properties } = this.props.tree;
        return (
            <>
                <NumberRule {...this.props} min={0} />
                {
                    properties.operator && <SelectTextField
                        name="unit"
                        size="small"
                        onChange={this.handleChange}
                        value={properties.unit != null ? properties.unit : ''}
                        placeholder="Unit"
                    >
                        <MenuItem value="ac">{'ac'}</MenuItem>
                        <MenuItem value="ha">{'ha'}</MenuItem>
                        <MenuItem value="m2">{'m²'}</MenuItem>
                        <MenuItem value="sqft">{'sqft'}</MenuItem>
                    </SelectTextField>
                }
            </>
        );
    }
}

export default AreaRule;